const GAZ_DELIVERY_CATEGORY_NAMES = new Set([
  "бордюр",
  "бордюр дорожный",
  "брусчатка",
  "брусчатка и тротуарная плитка",
  "плитка тротуарная",
  "газонная решетка",
  "лоток водоотводный жби",
  "лоток водоотводный тротуарный",
]);

export const normalizeRegionCode = (value) => {
  const normalized = String(value || "").trim().toUpperCase();
  if (normalized === "МОСКВА" || normalized === "МОСКОВСКАЯ ОБЛАСТЬ") {
    return "МСК";
  }
  if (normalized === "САНКТ-ПЕТЕРБУРГ" || normalized === "ЛЕНИНГРАДСКАЯ ОБЛАСТЬ") {
    return "СПБ";
  }
  return normalized;
};

export const shouldUseGazDeliveryCategoryByRegion = (region) => (
  ["МСК", "КРД"].includes(normalizeRegionCode(region))
);

export const isRegionalGikPriceSource = (source, region) => {
  const normalizedRegion = normalizeRegionCode(region);
  const normalizedSource = String(source || "").trim().toUpperCase();
  return ["МСК", "КРД"].includes(normalizedRegion) &&
    normalizedSource.includes(`ПРАЙС ГИК ${normalizedRegion}`);
};

export const isGazDeliveryCategoryForRegion = (value, region) => {
  const normalized = String(value || "").trim().toLowerCase();
  if (normalized.includes("газобетон")) {
    return true;
  }

  if (!GAZ_DELIVERY_CATEGORY_NAMES.has(normalized)) {
    return false;
  }

  return shouldUseGazDeliveryCategoryByRegion(region);
};

export const isGazFlowMaterial = (material = {}, region = null) => {
  const calculator = material?.calculatorCategory || material?.calculator || material?.CALCULATOR || "";
  const category = material?.category || material?.CATEGORY || "";
  const productGroup = material?.product_group || "";
  const source = material?.source || material?.SOURCE || "";
  const effectiveRegion = material?.region || material?.REGION || region;

  if (isGazDeliveryCategoryForRegion(calculator, effectiveRegion)) {
    return true;
  }

  if (String(calculator || "").trim().toLowerCase() === "газобетон и кирпич") {
    return true;
  }

  if (isGazDeliveryCategoryForRegion(category, effectiveRegion)) {
    return true;
  }

  if (isGazDeliveryCategoryForRegion(productGroup, effectiveRegion)) {
    return true;
  }

  if (isRegionalGikPriceSource(source, effectiveRegion)) {
    return true;
  }

  const normalizedProductGroup = String(productGroup || "").trim().toLowerCase();
  if (
    normalizedProductGroup.startsWith("u-блок") ||
    normalizedProductGroup === "клей" ||
    normalizedProductGroup === "добавка противоморозная"
  ) {
    return true;
  }

  const hasCategoryMetadata = [calculator, category, productGroup].some(
    (value) => String(value || "").trim().length > 0
  );
  const normalizedName = String(material?.name || "").trim().toLowerCase();

  if (!hasCategoryMetadata) {
    return normalizedName.includes("газобетон") || normalizedName.startsWith("u-блок");
  }

  return false;
};
